import { render } from "./FormLayout.vue?vue&type=template&id=ff7af892&scoped=true"
import script from "./FormLayout.vue?vue&type=script&lang=js"
export * from "./FormLayout.vue?vue&type=script&lang=js"

import "./FormLayout.vue?vue&type=style&index=0&id=ff7af892&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff7af892"]])

export default __exports__